<template>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-else>
        <v-row>
            <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
                <div class="title_page ma-3">
                <h4 class="breadcrumb_title_page">ค้นหาล็อต</h4>
                <v-breadcrumbs :items="sub_menu">
                    <template v-slot:divider>
                    <v-icon>mdi-chevron-right</v-icon>
                    </template>
                </v-breadcrumbs>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12 pt-0">
                <v-card elevation="4" style="border-radius: 15px;">
                    <v-card-text>
                        <div class="pa-4">
                            <v-form ref="#">
                                <v-row>
                                     <!-- ค้นหาล็อต -->
                                    <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                        <div class="d-flex">
                                            <div class="title_form_main">
                                                <div class="logo_timeline">
                                                    <img src="@/assets/arin_assets/box.png">
                                                </div>
                                            </div>
                                            <div class="header-content py-1 pl-5 pr-5 text-center">
                                                <div class="content-font">ค้นหาล็อต</div>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="11" lg="11" xl="11" cols="12">
                                        <v-form-group>
                                            <label class="label_form_text">รหัสล็อตสินค้า <span class="required--text">*</span></label>
                                            <v-autocomplete class="input-radius" v-model="lot_id" @change="addItem"
                                        :items="lot_list" item-value="id" placeholder="ค้นหาสินค้า..." single-line
                                        solo ref="product_list" :item-text="displayText" :search-input.sync="search" single outlined dense>
                                        <template slot="selection" slot-scope="{ item }">
                                           {{ item.product_name }} ({{item.lot_no}}) - Exp. {{item.date_expired}}
                                        </template>
                                        <template slot="item" slot-scope="{ item }">
                                            <v-list-tile-content>
                                                <p class='fullName'>{{ item.product_name }} ({{ item.lot_no }}) - Exp. {{item.date_expired}}</p>
                                            </v-list-tile-content>
                                        </template>
                                    </v-autocomplete>
                                        </v-form-group>
                                    </v-col>
                                    <v-col class="mt-2" xs="12" sm="12" md="1" lg="1" xl="1" cols="12">
                                        <div @click="showStock()" class="title_page ma-3" style="justify-content:center;">
                                            <v-btn type="button" class="btn_add_data" elevation="4" large>ค้นหา</v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            
            <v-col cols="12" class="mb-10">
                <Transition name="slide-fade">
                <v-card v-if="show" elevation="4" style="border-radius: 15px;">
                    <v-card-text>
                        <div class="pa-4">
                            <v-form ref="#">
                                <v-row>
                                     <!-- ค้นหาล็อต -->
                                    <v-col cols="12">
                                        <div class="d-flex">
                                            <div class="text-center">
                                                <div class="content-header-title">ข้อมูลล็อต</div>
                                            </div>
                                        </div>
                                    </v-col>
                                    
                                    
                                    <v-row class="border-color-milk">
                                        <v-col  xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="px-5">
                                            <div class="d-flex">ล๊อตสินค้า : {{data_list.lot_no}}</div>
                                        </v-col>
                                        <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="px-5">
                                            <div class="d-flex">ชื่อสินค้า : {{data_list.product_name}}</div>
                                        </v-col>
                                        <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="px-5 pt-1 pb-4">
                                            <div class="d-flex">วันหมดอายุ : {{data_list.date_expired}}</div>
                                        </v-col>
                                        <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="px-5 pt-1 pb-4">
                                            <div class="d-flex">ซัพพลายเออร์ : {{data_list.supplier_name != null ? data_list.supplier_name : '-'}}</div>
                                        </v-col>
                                    </v-row>

                                    <v-col cols="12" class="mt-5">
                                        <div class="d-flex">
                                            <div class="text-center">
                                                <div class="content-header-title">ประวัติการดำเนินการ</div>
                                            </div>
                                        </div>
                                    </v-col>

                                    <v-row class="border-color-milk">
                                        <v-col cols="12">
                                            <v-simple-table>
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left">
                                                                วันที่
                                                            </th>
                                                            <th class="text-left">
                                                                รายการ
                                                            </th>
                                                            <th class="text-left">
                                                                จำนวน
                                                            </th>
                                                            <th class="text-left">
                                                                ผู้ดำเนินการ
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{{ data_list.create_at }}</td>
                                                            <td>{{ data_list.product_name }}</td>
                                                            <td>{{ data_list.quantity }}</td>
                                                            <td>{{ data_list.user_name }}</td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-col>
                                    </v-row>
                                
                                </v-row>
                            </v-form>
                        </div>
                    </v-card-text>
                </v-card>
                </Transition>
            </v-col>
            
        </v-row>
    </div>
</template>

<script>
 import { HTTP_ARIN } from "@/axios_arin";
  export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Search_stock",
    data() {
        return {
            show: false,
            lot_id: null,
            sub_menu: [
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'คลังสินค้า',
                    disabled: false,
                },
                {
                    text: 'รายละเอียดสินค้า',
                    disabled: false,
                },
                {
                    text: 'ค้นหาล็อต',
                    disabled: false,
                    href: '#',
                },
            ],
            lot_list: [],
            data_list: [],
            search: ''
        }
    },
     methods: {
        displayText(item) {
      return `${item.product_name} (${item.lot_no}) - Exp. ${item.date_expired}`;
    },
       getLot_no(){
        const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        HTTP_ARIN.get('/pos/lot', config).then((res) => {
            if (res.data.successful === true) {
            this.lot_list = res.data.data
            this.loading_page = false;
            }
        })
        
       },
       showStock(){
        const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        HTTP_ARIN.get('/pos/lot/'+ this.lot_id, config).then((res) => {
            if (res.data.successful === true) {
             this.data_list = res.data.data[0];
            this.loading_page = false;
            this.show = true;
            }
        })
       }
    },
    mounted(){
        this.getLot_no();
    }
   
  }
</script>

<style>
.btn_add_data {
  font-size: 16px;
  color: rgb(255, 255, 255) !important ;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 100%;
}

.border-color-milk
{
    border: 1px solid #D6BFAF;
    border-radius: 10px;
    margin: 0;
}

.content-header-title {
    color: #616A6B;
    font-weight: 1000;
    font-size: 22px;
}

.title_form_main {
  background: #D6BFAF;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.logo_timeline {
  padding: 6px;
}


.logo_timeline>img {
  max-width: 25px;
}

/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */

.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

label.label_form_text {
  font-size: 16px !important;
  color: #616A6B !important;
}

.input-radius {
  border-radius: 10px;
}

.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

/*
  Enter and leave animations can use different
  durations and timing functions.
*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

@media only screen and (max-width: 600px) {

    .title_page h4.breadcrumb_title_page,
    .v-tab {
    font-size: 14px !important;
    }

    .v-timeline-item__divider {
    display: none !important;
    }

}
</style>